import React, { FC, memo, useMemo } from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { ReactComponent as EditIcon } from '../../../assets/icons/edit.svg'
import styles from './AutomatEditor.module.scss'
import { useAppSelector } from '../../hooks/store'
import { selectTastes } from '../../../store/slices/storage'

export type BunkerItemData = {
    id?: number
    automatModelContainerId: number
    tasteId: number
    isActive: boolean
    hasSmallDrink: boolean
}

type Props = {
    number: number
    bunker?: BunkerItemData
    onEdit: (number: number, bunker?: BunkerItemData) => void
}

/**
 *
 * @param bunker
 * @param onEdit
 * @returns
 */

const BunkerItem: FC<Props> = ({ number, bunker, onEdit }) => {
    const { t } = useTranslation()
    const tastes = useAppSelector(selectTastes)

    const tasteName = useMemo(() => {
        if (!bunker) {
            return t('114_AutomatEditor_empty')
        }

        return tastes.find((i) => i.id === bunker.tasteId)?.name || ''
    }, [tastes, bunker])

    return (
        <div className={styles.item}>
            <div className={styles.bunkerNumber}>
                {t('115_AutomatEditor_bunker')} {number}
            </div>
            <div
                className={classNames(styles.tasteName, {
                    [styles.tasteEmpty]: !bunker,
                })}
            >
                {tasteName}
            </div>
            <div onClick={() => onEdit(number, bunker)} className={styles.icon}>
                <EditIcon />
            </div>
        </div>
    )
}

export default memo(BunkerItem)
